import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { MenuClassification, MenuCsv, MenuDetail, SearchMenuFilter } from './models/menu';

const menuService = {
  getMenuDetailList(data: SearchMenuFilter): Promise<CommonResponse<Array<MenuDetail>>> {
    const expired_date = moment(data.expired_date).format(DATE_HYPHEN_FORMAT);
    const url = `/menu-details`;
    return axiosClient.post(url, { ...data, expired_date });
  },
  deleteMenu(data: Array<number>): Promise<CommonResponse<null>> {
    const url = `/delete-menu`;
    return axiosClient.patch(url, data);
  },
  getMenuClassification(): Promise<CommonResponse<Array<MenuClassification>>> {
    const url = `/menu-classification`;
    return axiosClient.get(url);
  },
  postMenuList(data: Array<MenuCsv>): Promise<CommonResponse<null>> {
    const url = `/import-menu`;
    return axiosClient.post(url, data);
  },
  getMenuImportCsvTemplate(): Promise<Blob> {
    const url = `/get-csv-template`;
    return axiosClient.get(url, { responseType: 'blob' });
  },
  restoreMenu(data: number): Promise<CommonResponse<null>> {
    const url = `/restore-menu`;
    return axiosClient.patch(url, data);
  },
  getOrderLimit(): Promise<CommonResponse<{ key: number; value: string }[]>> {
    const url = `/orders-limit`;
    return axiosClient.get(url);
  },
};

export default menuService;
